<template>
	<div id="AffiliateCard">
		<div class="card">
			<div class="card-body pb-3">
				<div class="row py-3">
					<div class="col-4">
						<img :src="handleImage()" class="rounded-circle img-fluid avatar-site" alt="">
					</div>
					<div :class="'col-8 text-right site-status ' + site.status">
						<small>{{statusList[site.status]}}{{ site.status == 'active'?' em ' + site.contract.hire:'' }}</small>
					</div>
					<div class="col-10">
						<p class="mb-0 black-text"><strong>{{site.name}}</strong></p>
						<p class="mb-0"><small>Desde {{site.created_at}}</small></p>
						<p class="mb-0"><a v-if="site.url" :href="'https://' + site.url" target="_blank" rel="noopener noreferrer" class="theme-color"><small><strong>{{site.url}}</strong></small></a></p>
						<!-- INSTAGRAM QUANDO TIVER <p class="mb-0"><small></small></p> -->
						<p class="mb-0"><small>{{site.email}}</small></p>
						<p class="mb-0" v-if="site.contact_phone"><small>{{`+${site.phonecode} ${site.contact_phone}`}}</small></p>
					</div>
					<div class="col-2 text-right external-links">
						<a v-if="instagram" :href="`${instagram.url_default}${instagram.username}`" target="_blank" rel="noopener noreferrer">
							<i class="fab fa-instagram"></i>
						</a>
						<a v-if="site.contact_phone" :href="`https://api.whatsapp.com/send?phone=${site.phonecode}${site.contact_phone}`" target="_blank" rel="noopener noreferrer">
							<i class="fab fa-whatsapp"></i>
						</a>
					</div>
					<div class="col-12" v-if="vendor && site.status == 'pending'">
						<div class="row">
							<div class="col-12" v-if="site.contract && site.contract.total && site.contract.bill.length && site.status != 'active'">
								<hr>
								<p class="small--text"  v-if="site.contract.discount">
								Valor: R$ {{site.contract.base}} - Desconto: R$ {{site.contract.discount}}
								<p>
								<p class="small--text">
								<strong>Total: R$ {{site.contract.total}}</strong>
								</p>
							</div>
							<div class="col-12" v-if="(!site.contract || site.contract.bill.length == 0) && site.status != 'active'">
								<button class="btn btn-primario btn-xsmall" @click="invoice = !invoice">Gerar Cobrança</button>
							</div>
							<div v-else-if="site.contract.bill.length > 0 && site.status != 'active'" class="col-12">
								<div class="row">
									<div :id="'data-bill-' + bill.id" v-for="(bill, index) in site.contract.bill" :key="bill.id" class="col-12">
										<button 
											class="btn btn-primario btn-xsmall"
											@click="copyLink(bill)">
											Link Cobrança{{bill.status == 'expired'?' em atraso':'' }} {{index + 1}}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
         	</div>
      	</div>

		<div class="row py-5" v-if="invoice">
			<div class="col-12 mb-5">
				<h4 class="text-center">Gerar Cobrança</h4>
			</div>
			<div class="col-12">
				<select class="bg-white w-100" v-model="plan" @change="split = []; pushSplitItem();">
				<option :value="null" disabled selected>Selecione...</option>
				<option v-for="plan in plans" :key="plan.id" :value="plan">{{plan.name}} - {{plan.subtitle}}</option>
				</select>
			</div>
			<div v-if="plan" class="col-12">
				<div class="row">
					<div class="col-6">
						<p class="mb-0 small--text">Aplicar cupom</p>
						<input type="text" class="form-control" v-model="promoCode" @keyup="getCode">
					</div>
					<div class="col-6">
						<div v-if="code && plan && parseInt(code.discount) > 0">
							<p class="small--text">
								<strong>R$ {{code.discount}}</strong> de desconto
							</p>
							<p class="small--text">
								De R$ {{rawValue()}} por <strong>R$ {{totalValue()}}</strong>
							</p>
						</div>
						<div v-else>
							<p class="small--text">
								Sem desconto.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div v-if="plan" class="col-12">
				<p class="small--text">
					O cliente pode escolher forma de pagamento em 12x no cartão ou 1x no Boleto. Para receber entrada ou parcelar no Boleto, gere manualmente conforme combinou com o cliente:
				</p>
				<div v-if="split.length > 0" class="row">
					<div class="col-2">
						<p class="mb-0 small--text">Parcela</p>
					</div>
					<div class="col-3">
						<p class="mb-0 small--text">Valor</p>
					</div>
					<div class="col-4">
						<p class="mb-0 small--text">Prazo</p>
					</div>
					<div class="col-3">
						<p class="mb-0 small--text">Máximo</p>
					</div>
				</div>
				<div v-for="(item, index) in split" :key="index" class="row invoice-list">
					<div class="py-2 col-2">
						<span>{{index + 1}}</span>
					</div>
					<div class=" col-3">
						<input class="form-control" type="number" v-model="split[index].value" @keyup="countRemainingItems(index)" :disabled="(index + 1) == split.length">
					</div>
					<div class=" col-4">
						<vuejs-datepicker :popover="{ visibility: 'click' }"
							mode="single"
							v-model="split[index].expiry_date"
							color="purple"
							:language="ptBR"
							:input-props="{
								class: 'input-picker form-control',
							}"></vuejs-datepicker>
					</div>
					<div class=" col-2">
						<select class="bg-white w-100 form-control" v-model="split[index].max">
							<option value="1">1x</option>
							<option value="2">2x</option>
							<option value="3">3x</option>
							<option value="4">4x</option>
							<option value="5">5x</option>
							<option value="6">6x</option>
							<option value="7">7x</option>
							<option value="8">8x</option>
							<option value="9">9x</option>
							<option value="10">10x</option>
						</select>
					</div>
					<div v-if="split.length > 1" class="py-2 px-0 col-1 text-center">
						<i class="fal fa-trash-alt" @click="removeSplitItem(index)"></i>
					</div>
				</div>
				<i v-if="plan && split.length < 10" class="fal fa-plus-circle round-fa" @click="pushSplitItem()"></i>
				<div v-if="split.length > 0" class="row mt-3">
					<div class="col-6">
						<button class="btn btn-primario float-left" @click="saveSplit()">Salvar</button>
					</div>
					<div class="col-6 text-right">
						<button class="btn btn-secundario float-right" @click="invoice = !invoice">Cancelar</button>
					</div>
				</div>
				<div v-if="split.length > 0 && message" class="row">
					<p class="error-message">{{message}}</p>
				</div>
			</div>
      	</div>
	</div>
</template>

<script>

import axios from 'axios';
import vuejsDatepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
	name: 'AffiliateCard',
	components:{
		vuejsDatepicker
	},
	props:{
		site: {
			type: Object,
		},
		filter:{
			type: Number,
		},
		plans: {
			type: Array,
			default: []
		},
		vendor: {
			type: Boolean,
			default: false
		},
		code: {
			type: Object,
			default: null
		}
	},
   	data(){
		return {
			instagram: null,
			invoice: false,
			split: [],
			plan: null,
			api: null,
			message: null,
			promoCode: null,
			statusList: {
				active: 'Ativo',
				pending: 'Pendente',
				canceled: 'Cancelado'
			},
			ptBR: ptBR
      }
   	},
	created(){
		var instagram = this.site.integrations.filter(
			(integration) => integration.name == 'Instagram'
		);

		if(instagram){
			this.instagram = instagram[0];
		}

		this.api = process.env.ROOT_API;
		this.promoCode = this.code.partner_promo_code;
   },
   	methods:{
		round(num){
			return Math.round((num + Number.EPSILON) * 100) / 100;
		},
		copyLink(bill){
			if (!navigator.clipboard) {
				//return false;
			}
			navigator.clipboard.writeText(bill.url).then(function() {
				//return true;
				alert('Link copiado com sucesso.');
			},function(err) {
				//return false;
			});
		},
		getCode: _.debounce(function (e) {
			let url = this.api + '/api/code/' + this.promoCode;

			let token = this.$session.get("jwt");

			axios({
				method: "get",
				url: url,
				headers: {
					Authorization: "Bearer " + token
				}
			}).then(response => {
				if (response.data.status == "1") {
					this.code = {
						id: response.data.id,
						partner_promo_code: response.partner_promo_code,
						discount: response.data.discount
					}
					this.recalcSplit();
				}
			}).catch(response => {
				this.message = 'Houve um erro ao gerar as faturas.';
			});
		}, 400),
		saveSplit(){
			let url = this.api + '/api/contract/split';
			this.message = null;

			let postdata = {
				split: this.split,
				site: this.site.id,
				plan: this.plan.id,
				code: this.code ? this.code.id : null
			}

			let token = this.$session.get("jwt");

			axios({
				method: "post",
				url: url,
				data: postdata,
				headers: {
				Authorization: "Bearer " + token
				}
			}).then(response => {
				if (response.data.status == "1") {
				this.invoice = false;
				this.$emit('reload');
				} else {
				this.message = response.data.message;
				}
			}).catch(response => {
				this.message = 'Houve um erro ao gerar as faturas.';
			});
		},
		countRemainingItems(index){
			let plan = this.plan;
			let remaining = 0;
			let remainingLast = 0;

			//Calculando valor total do plano
			let total = this.totalValue();

			//Calcula o valor já preenchido até o indice que foi alterado
			remaining = total;
			for (let i = 0; i <= index; i++) {
				remaining = parseFloat(remaining) - parseFloat(this.split[i].value);
			}

			//Calculando valor restante a ser dividido nas demais faturas
			remainingLast = remaining;
			for (let i = (index + 1); i < this.split.length; i++) {
				this.split[i].value = this.round(remaining / (this.split.length - (index + 1)));
				remainingLast = remainingLast - this.split[i].value;
			}
			console.log(remainingLast)
			this.split[this.split.length-1].value += remainingLast;

			return true;
		},
		removeSplitItem(index){
			this.split.splice(index, 1);
			this.recalcSplit()

			return true;
		},
		handleImage(){
			return process.env.CDN_URL + this.site.logo
		},
		pushSplitItem(){
			//Calculando valor total do plano
			let total = this.totalValue();

			let item = {
				value: 0,
				expiry_date: this.generateExpirationDate(),
				max: 1
			};

			if(this.split.length > 0){
				console.log('entrou no if');
				let last = this.split[this.split.length - 1];
				item.expiry_date.setDate(item.expiry_date.getDate() + 7);
			}
			else{
				console.log('entrou no else');
				item.expiry_date.setDate(item.expiry_date.getDate() + 2);
			}

			this.split.push(item);

			this.recalcSplit();

			return true;
		},
		generateExpirationDate(){
			if(this.split.length > 0){
				return this.split[this.split.length-1].expiry_date;
			}else{
				return new Date;
			}
		},
		rawValue(){
			let plan = this.plan;
			let total = parseFloat(plan.support);
			
			if(plan.price_cicle > 1){
				total = total + parseFloat(plan.price_value);
			}
			else if(total == 0){
				total = parseFloat(plan.price_value);
			}

			return total;
		},
		totalValue(){
			let total = this.rawValue();
			let discount = 0;
			if(this.code){
				discount = parseInt(this.code.discount);
			}
			return total - discount;
		},
		recalcSplit(){
			//Calculando valor total do plano
			let total = this.totalValue();
			let value = 0;
			let remaining = total;
			
			//Pegando o valor restante e dividindo para as demais parcelas adiante
			for (let i = 0; i < this.split.length; i++) {
				if(i == (this.split.length - 1)){
				this.split[i].value = remaining;
				}
				else{
				value = total / ( this.split.length );
				this.split[i].value = this.round(value);
				remaining = remaining - this.split[i].value;
				}
			}
		}
   	}
}
</script>

<style scoped>
.card{
   	color: #777;
}
.avatar-site{
	width: 39px;
	height: 39px;
	object-fit: cover;
}
.black-text{
   	color: #000;
}
.theme-color{
   	color: var(--main-color);
}
.site-status small{
	background-color: #eee;
	color: #777;
	padding: 0 15px 4px;
	border-radius: 16px;
	cursor: pointer;
	font-size: 0.8rem;
}
.site-status.active small{
   	background-color: #CFF5D4;
}
.site-status.pending small{
   	background-color: #F2F2F2;
}
.site-status.canceled small{
   	background-color: #FFCCCC;
}
.external-links a{
   	font-size: 1.8rem;
   	color: #aaa;
}
.invoice-list, .invoice-list input, .invoice-list select{
	font-size: 0.8rem;
}
</style>

<style>
.vdp-datepicker__calendar{
   	left: -120px;
}
.vdp-datepicker input{
	width: 100%;
	padding: 6px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/AffiliateCard.vue